import {atom} from "recoil";
import {persistAtomEffect} from "../effects/persistAtom";

export const sidebarOpenedMenuItemState = atom({
  key: 'SidebarOpenedMenuItemState',
  default: [],
  effects: [
    persistAtomEffect
  ]
});
